import React from 'react';

const HouseholdProfile = () => {
  return <h1>Household Profile</h1>;
};

export default HouseholdProfile;
